import { useContext, useEffect, useRef } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import {Color, Entity, CallbackProperty, Cartesian3, ArcType, Material, PolylineDashMaterialProperty} from 'cesium';
interface Props {
    pos: number[];
    size: number;
    color: number[];
}

export default function Orbit(props: Props) {
    const viewer = useContext(CesiumViewerContext);
    const entityRef = useRef<Entity>();
    useEffect(() => {
console.log("init orbit plane", props.pos);
        if (!viewer) {
            return () => { }
        }
        if(props.pos.length < 3)
        {
            props.pos.push(0.0);
            props.pos.push(0.0);
            props.pos.push(0.0);
        }
        const positions = new CallbackProperty(() => {
            return Cartesian3.fromDegreesArrayHeights(props.pos);
        }, true);
        const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], 255);
        const e = viewer.entities.add({
            polyline: {
                width: props.size,
                positions,
                material,
                arcType: ArcType.NONE
            }
        } as any);
        entityRef.current = e;
        return () => { viewer!.entities.remove(e) }
    }, [viewer]);

    useEffect(() => {
console.log("update orbit plane", props.pos);
        if ((!entityRef.current) || (props.pos.length < 3)) {
            return;
        }
console.log("update line", props.pos);
        const entity = entityRef.current;
        (entity as any).polyline.positions.setCallback(() => {
            return Cartesian3.fromDegreesArrayHeights(props.pos)
        }, false);
    }, [props.pos]);
    
    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).polyline.width.setValue(props.size);
    }, [props.size]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], 255);
        (entity as any).polyline.material = material;
    }, [props.color]);

    return null;
}
